import React from 'react';
import { Modal } from '../../../CommonComponents/OPL/Modal/Modal';
import { Box } from '../../../CommonComponents/OPL/Box/Box';
import { Loading } from '../../../CommonComponents/OPL/Loading/Loading';

export const AuthenticateFidelityEntityLoading = () => (
  <Modal isOpen shouldCloseOnOverlayClick={false} size="medium">
    <Box display="flex" justifyContent="center" alignItems="center" height={300}>
      <Loading text="logging into fidelity" />
    </Box>
  </Modal>
);
